import { PhoneCountryCodeType } from '@bus/models';
import { CorrespondenceMethodEnum } from '../../../../../types/forms';
import { ContactPersonFormModel_OL } from './formModel';

export const getInitialValues = (): ContactPersonFormModel_OL => {
  return {
    title: undefined,
    firstName: undefined,
    lastName: undefined,
    jobTitle: undefined,
    correspondenceMethod: CorrespondenceMethodEnum.email,
    countryCode: PhoneCountryCodeType.Ireland,
    phoneNumber: undefined,
    email: undefined,
  };
};
